import "./Register.css";
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom"; // For navigation
import { register } from "../utils/api"; // Import register function

function Register() {
  const [formData, setFormData] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");
    try {
      const data = await register(formData.name, formData.email, formData.password);
      setLoading(false);
      if (data.status === "success") {
        setSuccessMessage(data.message || "Registration successful! Redirecting to login...");
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (err) {
      setLoading(false);
      setError(err.message || "An error occurred. Please try again.");
    }
  };

  return (
    <div className="register-page">
      {/* Top Navigation Bar */}
      <div className="top-nav">
        <div className="nav-content">
          <div className="nav-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            <img src="/HDASLogo.png" alt="HDAS" style={{ height: "80px", width: "auto" }} />
          </div>
          <div className="nav-buttons">
            <button className="nav-button sign-in" onClick={() => navigate("/login")}>
              Sign In
            </button>
            <button className="nav-button get-started" onClick={() => navigate("/register")} style={{ opacity: 1 }}>
              Get Started
            </button>
          </div>
        </div>
      </div>

      <div className="register-container">
        <div className="register-form-container">
          <div className="tagline">Get Started Today</div>
          <h2>Create your account</h2>
          <p className="form-subtitle">Start analyzing your healthcare data in minutes</p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className="input-group">
              <label>Email address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email address"
                required
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Password"
                required
              />
            </div>
            <button type="submit" className="register-button" disabled={loading}>
              {loading ? "Registering..." : "Register"}
            </button>

            {error && (
              <div className="error-message" style={{ marginTop: "12px", padding: "10px 14px", background: "#fff0f0", border: "1px solid #f5c6cb", borderRadius: "6px", color: "#c0392b", display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>!</span>
                <span>{error}</span>
              </div>
            )}

            {successMessage && (
              <div style={{ marginTop: "12px", padding: "10px 14px", background: "#f0fff4", border: "1px solid #b2dfdb", borderRadius: "6px", color: "#1e8449", display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ fontWeight: "bold" }}>✓</span>
                <span>{successMessage}</span>
              </div>
            )}
          </form>
          <div className="register-footer">
            <p>
              Already have an account? <Link to="/login">Login here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
